import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getSubscription } from "../../services/paymentService";

const PlanStatusCard = ({
  planName: propPlanName,
  status: propStatus,
  subscriptionDetails: propSubscriptionDetails,
}) => {
  const { token } = useSelector((state) => state.auth);

  // Local states if props aren't provided
  const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // If we have explicit props, no need to fetch
    if (propSubscriptionDetails || propPlanName !== undefined || propStatus !== undefined) {
      return;
    }

    if (!token) return;

    const fetchSubscription = async () => {
      setLoading(true);
      try {
        const subResponse = await getSubscription(token);
        if (subResponse.success && subResponse.hasSubscription && subResponse.subscription.status === 'active') {
          setSubscriptionDetails(subResponse.subscription);
        }
      } catch (error) {
        console.error("Error loading subscription data in PlanStatusCard:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSubscription();
  }, [token, propSubscriptionDetails, propPlanName, propStatus]);

  // Determine current active subscription
  const activeSub = propSubscriptionDetails || subscriptionDetails;

  const finalPlan = propPlanName || activeSub?.plan || "Free";
  const finalStatus = propStatus !== undefined ? propStatus : (activeSub?.status === "active" ? "active subscription" : "");

  return (
    <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm flex flex-col justify-between flex-1">
      <div className="flex justify-between items-start">
        <div>
          <h3 className="text-gray-600 font-medium mb-2">Plan Status</h3>
          <h2 className="text-2xl font-bold text-gray-900">
            {loading && !propPlanName ? "Loading..." : finalPlan}
          </h2>
          {finalStatus && (
            <p className="text-gray-500 text-sm mt-1">{finalStatus}</p>
          )}
        </div>
        <span className="bg-primary text-yellow-800 text-xs font-semibold px-3 py-1 rounded-full">
          {finalPlan.replace("NKENNEAi", "").replace("NKENNE", "").trim() || "Free"}
        </span>
      </div>
    </div>
  );
};

export default PlanStatusCard;
